import { Routes, Route, Navigate } from 'react-router-dom';
import { useUserStore } from '@/store/userSlice';
import { AppLayout } from '@/components/templates/AppLayout';
import { DashboardPage } from '@/pages/DashboardPage/DashboardPage';
import { TemplatesPage } from '@/pages/TemplatesPage/TemplatesPage';
import { TemplateEditPage } from '@/pages/TemplateEditPage/TemplateEditPage';
import { VisitsPage } from '@/pages/VisitsPage/VisitsPage';
import { VisitPage } from '@/pages/VisitPage/VisitPage';
import { WorkersPage } from '@/pages/WorkersPage/WorkersPage';
import { WorkerEditPage } from '@/pages/WorkerEditPage/WorkerEditPage';
import { ClientsPage } from '@/pages/ClientsPage/ClientsPage';
import { ClientEditPage } from '@/pages/ClientEditPage/ClientEditPage';
import { LocationsPage } from '@/pages/LocationsPage/LocationsPage';
import { LocationPage } from '@/pages/LocationPage/LocationPage';
import { PaymentsPage } from '@/pages/PaymentsPage/PaymentsPage';
import { ReportsPage } from '@/pages/ReportsPage/ReportsPage';
import { LoginPage } from '@/pages/LoginPage/LoginPage';
import { RegisterPage } from '@/pages/RegisterPage/RegisterPage';

export function AppRouter() {
  const isAuthenticated = useUserStore((s) => s.isAuthenticated);
  const isStaff = useUserStore((s) => s.isStaff);
  const user = useUserStore((s) => s.user);

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // Онбординг клиента: карточка организации не сохранялась ни разу —
  // все разделы закрыты формой данных (гейт до первого сохранения,
  // как анкета воркера в мобильном приложении). confirmed = undefined
  // (персонал/старые сессии) считается подтверждённым.
  const isOnboarded = isStaff || (user?.confirmed ?? true);

  if (!isOnboarded) {
    return (
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/profile" element={<ClientEditPage mode="self" />} />
          <Route path="*" element={<Navigate to="/profile" replace />} />
        </Route>
      </Routes>
    );
  }

  // Домашний раздел для всех ролей — дашборд
  const homePath = '/dashboard';

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/templates" element={<TemplatesPage />} />
        {/* Создание — сразу POST на кнопке списка: /templates/:id открывается
            на только что созданном шаблоне в статусе new (режим правки) */}
        <Route path="/templates/:id" element={<TemplateEditPage />} />
        <Route path="/visits" element={<VisitsPage />} />
        <Route path="/visits/:id" element={<VisitPage />} />
        <Route path="/locations" element={<LocationsPage />} />
        <Route path="/locations/new" element={<LocationPage />} />
        <Route path="/locations/:id" element={<LocationPage />} />
        <Route path="/workers" element={<WorkersPage />} />
        <Route path="/workers/new" element={<WorkerEditPage />} />
        <Route path="/workers/:id" element={<WorkerEditPage />} />
        {/* Форма данных своей организации (роль client) */}
        {!isStaff && <Route path="/profile" element={<ClientEditPage mode="self" />} />}
        {isStaff && (
          <>
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/clients/new" element={<ClientEditPage />} />
            <Route path="/clients/:id" element={<ClientEditPage />} />
          </>
        )}
        {isStaff && <Route path="/payments" element={<PaymentsPage />} />}
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="*" element={<Navigate to={homePath} replace />} />
      </Route>
      <Route path="/login" element={<Navigate to={homePath} replace />} />
      <Route path="/register" element={<Navigate to={homePath} replace />} />
      <Route path="*" element={<Navigate to={homePath} replace />} />
    </Routes>
  );
}
